import * as React from 'react';
import {
  DynamicCalltrackingLink,
  EPageTypes,
  EPlatformTypes,
  DynamicCalltrackingContext,
} from '@cian/frontend-dynamic-calltracking-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import { clsx } from 'clsx';
import * as styles from './MobileCall.css';
import { ApplicationContext } from '../../utils';

interface IMobileCallButton {
  onClick(): void;
  phone: string;
  placeType: string;
  buttonText: string;
  siteBlockId?: number | null;
  size?: TButtonSize;
  theme?: TButtonTheme;
  fullWidth?: boolean;
}

export const MobileCallButton = ({
  phone,
  placeType,
  buttonText,
  siteBlockId,
  size,
  theme = 'fill_primary',
  fullWidth = true,
  onClick,
}: IMobileCallButton) => {
  const { logger, httpApi } = React.useContext(ApplicationContext);

  const context = React.useMemo(() => ({ logger, httpApi }), [logger, httpApi]);

  return (
    <DynamicCalltrackingContext.Provider value={context}>
      <DynamicCalltrackingLink
        onClick={onClick}
        phone={phone}
        blockId={siteBlockId}
        platformType={EPlatformTypes.WebMobile}
        pageType={EPageTypes.NewbuildingCard}
        className={clsx(
          styles['button'],
          size && styles[`button__${size.toLowerCase()}`],
          theme && styles[`button__${theme.toLowerCase()}`],
          fullWidth && styles['button__full-width'],
        )}
        placeType={placeType}
      >
        <div className={styles['button-content']} data-testid={`CallButtonContent-${placeType}`}>
          <IconCommunicationPhone16 color="current_color" />
          <span data-testid="CallText">{buttonText}</span>
        </div>
      </DynamicCalltrackingLink>
    </DynamicCalltrackingContext.Provider>
  );
};
